import React from 'react';
import AddEditBlogForm from 'ui-component/blog/AddEditBlogForm';
import { usePermissions } from 'hooks/usePermissions';
import { MODULE_KEYS } from 'store/constant';

function EditBlog() {
  const { hasWritePermission } = usePermissions();
  const canEdit = hasWritePermission(MODULE_KEYS.Blogs)
  const title = canEdit ? "Edit Blog" : "View Blog"
  return (
    <div>
      <AddEditBlogForm title={title} />
    </div>
  )
}

export default EditBlog;